import { ref } from "vue";
export const toastMessage = ref("");
let toastTimer;
export function toast(message) {
  toastMessage.value =
    typeof message === "string"
      ? message
      : message?.resultNote || message?.message || "操作失败，请重试";
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    toastMessage.value = "";
  }, 2400);
}
export const dialog = ref(null);
const queue = [];
function nextDialog() {
  if (!dialog.value && queue.length) dialog.value = queue.shift();
}
export function confirmAction(content, options = {}) {
  if (typeof content === "object") {
    options = content;
    content = options.content;
  }
  return new Promise((resolve) => {
    queue.push({
      title: "提示",
      confirmText: "确定",
      cancelText: "取消",
      ...options,
      content: content || "",
      resolve,
    });
    nextDialog();
  });
}
export function answerDialog(answer) {
  const current = dialog.value;
  dialog.value = null;
  current?.resolve(Boolean(answer));
  nextDialog();
}
